/** @type {import("@mui/material").SxProps<Theme>} */
const styles = theme => ({
  mainContainer: {
    maxWidth: '100vw !important',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexDirection: 'column',
    // [theme.breakpoints.down('sm')]: {
    marginLeft: '0 !important',
    marginRight: '0 !important',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',

    // },
  },
  containerMobileOffer: {
    // maxWidth: 900,
    background: theme.palette.secondary.contrastText,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      // paddingLeft: 2,
      // paddingRight: 2,
    },
  },
  toggleButtonsContainer: {
    background: theme.palette.secondary.mobileToggleColor,
    // borderRadius: '100px',
  },
  containerToggle: {
    justifyContent: 'center',
    padding: '3rem 2.5rem 0rem 2.5rem',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  mobileOfferName: {
    color: theme.palette.secondary.mobileInActiveToggleFontColor,
    textTransform: 'none',
    paddingLeft: '0.5rem',
    paddingRight: '0.25rem',
  },
  mobileOfferNameOne: {
    textTransform: 'lowercase',
    paddingRight: '0.5rem',
    color: theme.palette.secondary.mobileActiveToggleBackground,
  },
  offerButtons: {
    '& .MuiToggleButtonGroup-root': {
      // background: theme.palette.secondary.contrastText,
      // borderRadius: '100px',
    },
    '&.Mui-disabled': {
      border: 0,
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.primary.offerMain,
      '&:hover': {
        backgroundColor: theme.palette.primary.offerMain,
      },
      '& .MuiTypography-root': {
        color: theme.palette.secondary.contrastText,
      },
    },
  },
  submitCTAContainerMobile: {
    display: 'flex',
    justifyContent: 'center',
    mt: '1rem',
    mb: '7rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      p: '0 1rem',
    },
  },
  submitCTAmobile: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '21px!important',
      width: '100%',
    },
    border: `3px solid ${theme.palette.secondary.errorCTA}`,
    cursor: 'pointer',
    fontSize: '16px',
    borderRadius: '100px',
    textTransform: 'capitalize',
    width: '6.625rem',
    height: '40px',
    background: theme.palette.secondary.errorCTA,
    color: theme.palette.secondary.contrastText,
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px  ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
    '&:hover': {
      background: theme.palette.secondary.errorCTA,
      color: theme.palette.secondary.contrastText,
      boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px  ${theme.palette.primary.boxShadow1Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow1Lite}`,
    },
  },
  faqContainerSuperMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '6rem',
  },
});

export default styles;
